/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig, FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig';
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfig(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauthConfigToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsOauth.js.map